import { defineMessages } from 'react-intl';
// Note: The value 72 below must match ATTENDANCE_INQUIRY_RESPONSE_DEADLINE_HOURS in constants/logic.js
// We can't use the constant directly here because babel-plugin-react-intl doesn't evaluate template literals during extraction

export default defineMessages({
  title: {
    id: 'home.attendance-inquiry-modal.title',
    defaultMessage: 'Attendance verification needed',
  },
  progress: {
    id: 'home.attendance-inquiry-modal.progress',
    defaultMessage: '{current} of {total}',
  },
  responseDeadline: {
    id: 'home.attendance-inquiry-modal.response-deadline',
    defaultMessage: '{hours} hours {minutes} mins to respond',
  },
  description: {
    id: 'home.attendance-inquiry-modal.description',
    defaultMessage:
      'A ClassPass member reported that they were unable to attend the following reservation because it did not take place. Please review the reservation details below and, within {hours} hours {minutes} mins, confirm whether the reservation took place or did not occur.',
  },
  verifyInstruction: {
    id: 'home.attendance-inquiry-modal.verify-instruction',
    defaultMessage:
      'Please verify by reviewing the following information and selecting one of the options within the next 72 hours:*',
  },
  greetingHello: {
    id: 'home.attendance-inquiry-modal.greeting-hello',
    defaultMessage: 'Hello {name},',
  },
  descriptionUserNotAllowed: {
    id: 'home.attendance-inquiry-modal.description-user-not-allowed',
    defaultMessage:
      'A ClassPass member reported that they were turned away upon arrival for the following reservation.',
  },
  verifyInstructionUserNotAllowed: {
    id: 'home.attendance-inquiry-modal.verify-instruction-user-not-allowed',
    defaultMessage:
      'Please verify by reviewing the following information and selecting one of the options within the next 72 hours:*',
  },
  reservationDetailsTitle: {
    id: 'home.attendance-inquiry-modal.reservation-details-title',
    defaultMessage: 'Reservation details',
  },
  userName: {
    id: 'home.attendance-inquiry-modal.user-name',
    defaultMessage: 'User name:',
  },
  reservationName: {
    id: 'home.attendance-inquiry-modal.reservation-name',
    defaultMessage: 'Reservation name:',
  },
  date: {
    id: 'home.attendance-inquiry-modal.date',
    defaultMessage: 'Date:',
  },
  time: {
    id: 'home.attendance-inquiry-modal.time',
    defaultMessage: 'Time:',
  },
  buttonTookPlace: {
    id: 'home.attendance-inquiry-modal.button-took-place',
    defaultMessage: 'This reservation took place',
  },
  buttonDidNotOccur: {
    id: 'home.attendance-inquiry-modal.button-did-not-occur',
    defaultMessage: 'This reservation did not occur',
  },
  buttonUserAllowedIn: {
    id: 'home.attendance-inquiry-modal.button-user-allowed-in',
    defaultMessage: 'User was allowed in',
  },
  buttonUserNotAllowedIn: {
    id: 'home.attendance-inquiry-modal.button-user-not-allowed-in',
    defaultMessage: 'User was NOT allowed in',
  },
  disclaimerUpdated: {
    id: 'home.attendance-inquiry-modal.disclaimer-updated',
    defaultMessage: 'You have 72 hours to respond to attendance verifications.',
  },
  selectResponse: {
    id: 'home.attendance-inquiry-modal.select-response',
    defaultMessage: 'Please select a response:',
  },
  buttonNext: {
    id: 'home.attendance-inquiry-modal.button-next',
    defaultMessage: 'Next',
  },
  buttonBack: {
    id: 'home.attendance-inquiry-modal.button-back',
    defaultMessage: 'Back',
  },
  buttonSubmitAll: {
    id: 'home.attendance-inquiry-modal.button-submit-all',
    defaultMessage: 'Submit All',
  },
  buttonClose: {
    id: 'home.attendance-inquiry-modal.button-close',
    defaultMessage: 'Close',
  },
  summaryTitle: {
    id: 'home.attendance-inquiry-modal.summary-title',
    defaultMessage: 'Responses saved',
  },
  summaryUserAllowedInTitle: {
    id: 'home.attendance-inquiry-modal.summary-user-allowed-in-title',
    defaultMessage: 'User was allowed in',
  },
  summaryUserNotAllowedInTitle: {
    id: 'home.attendance-inquiry-modal.summary-user-not-allowed-in-title',
    defaultMessage: 'User was NOT allowed in',
  },
  summaryTookPlaceTitle: {
    id: 'home.attendance-inquiry-modal.summary-took-place-title',
    defaultMessage: 'This reservation took place',
  },
  summaryDidNotOccurTitle: {
    id: 'home.attendance-inquiry-modal.summary-did-not-occur-title',
    defaultMessage: 'This reservation did not take place',
  },
  summaryWhatHappensNext: {
    id: 'home.attendance-inquiry-modal.summary-what-happens-next',
    defaultMessage: 'What happens next:',
  },
  summaryUserAllowedInDescription: {
    id: 'home.attendance-inquiry-modal.summary-user-allowed-in-description',
    defaultMessage:
      'Since you confirmed the member(s) were allowed in for the following reservation(s), they will not be refunded their credits and you will receive your agreed payout for this reservation.',
  },
  summaryUserNotAllowedInDescription: {
    id: 'home.attendance-inquiry-modal.summary-user-not-allowed-in-description',
    defaultMessage:
      'Since you confirmed the member(s) were denied access to the following reservation(s), they will be refunded their credits and you will not receive a payout for these reservations',
  },
  summaryTookPlaceDescription: {
    id: 'home.attendance-inquiry-modal.summary-took-place-description',
    defaultMessage:
      'What happens next: Since you confirmed the following reservation(s) <bold>took place</bold>, the member(s) will not be refunded their credits and you will receive your agreed payout for this reservation.',
  },
  summaryDidNotOccurDescription: {
    id: 'home.attendance-inquiry-modal.summary-did-not-occur-description',
    defaultMessage:
      'Since you confirmed the following reservation(s) <bold>did not take place</bold>, the member(s) will be refunded their credits and you will not receive a payout for these reservations.',
  },
  bannerDescription: {
    id: 'home.attendance-inquiry-banner.description',
    defaultMessage: 'A ClassPass member disputed their attendance. You have 72 hours to respond.',
  },
  requestedInquiryNotFound: {
    id: 'home.attendance-inquiry-modal.requested-inquiry-not-found',
    defaultMessage: 'The requested inquiry is not available, but you can respond to the other inquiries below.',
  },
});
